import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'orderBy',
    standalone: true
})
export class OrderByPipe implements PipeTransform {
    transform(value: any[], args: string): any[] {
        return value.sort((a, b) => a[args] - b[args]);
    }
}

